// extracted by mini-css-extract-plugin
module.exports = {"locationsForm":"LocationsTable_locationsForm__1YWxy","submitButton":"LocationsTable_submitButton__ntRAS"};